import { Chatmessage, ChatmessageThread } from "simpleloan_api";

export function getShortMessage(message: Chatmessage) {
  return message.message ? message.message : message.file ? 'Файл' : ''
}

export function getThreadShortMessage(thread: ChatmessageThread) {
  return thread.latest_short_message ? thread.latest_short_message : thread.file ? 'Файл' : ''
}